import { ApiPropertyOptional } from '@nestjs/swagger'
import {
  IsOptional,
  IsDateString,
  IsInt,
  IsBoolean,
  Min,
} from 'class-validator'
import { Type } from 'class-transformer'

export class UpdateActivityUserAssignmentDto {
  @ApiPropertyOptional({
    description: 'Date de disponibilité (ISO 8601)',
  })
  @IsOptional()
  @IsDateString()
  availableFrom?: string

  @ApiPropertyOptional({
    description: "Date d'échéance (ISO 8601)",
  })
  @IsOptional()
  @IsDateString()
  dueAt?: string

  @ApiPropertyOptional({
    description: 'Nombre maximum de tentatives',
  })
  @IsOptional()
  @Type(() => Number)
  @IsInt()
  @Min(1)
  maxAttempts?: number

  @ApiPropertyOptional({
    description: 'Afficher les solutions après soumission',
  })
  @IsOptional()
  @IsBoolean()
  showSolutions?: boolean
}
